import { Component, Inject } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { AppDataService } from "@app/services/appData.service";

@Component({
    selector: 'app-pay-by-mail',
    template: require('./payByMail.html')
})

export class PayByMailComponent {

    constructor(
        @Inject(WindowToken) private window: Window,
        @Inject(AppDataService) private appDataService: AppDataService,
    ) {}

    goToWelcomePage() {
        const webUrl = this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL
        this.window.location.replace(webUrl)
    }

}
